import { DomSanitizer } from '@angular/platform-browser';
import { NoteAndActivityTypeEnum } from 'src/app/recruiting/candidates/new-profile/models/notes-and-activities.enum';
import {
    NotesAndActivities,
    NotesAndActivitiesOrientationNote
} from 'src/app/recruiting/candidates/new-profile/models/notes-and-activities.model';

export class NotesHelper {
    static getRawHtml = (text: string, noteType: NoteAndActivityTypeEnum, sanitizer: DomSanitizer) => {
        if (text?.length > 0 && noteType === NoteAndActivityTypeEnum.SystemEmail) {
            text = text.replace('Automated Missing and Expiring Notification Email sent to candidate.', '');
            text = text.replace(/n\/a/g, 'Missing');
            text = text.replace('&nbsp;', '');
            text = text.replace(/<table aria-label="spacer"\s|.*<\/table>/gi, '');
            text = text.replace(/<br>\s|.*<table/gi, '<table');
        }
        return sanitizer.bypassSecurityTrustHtml(text);
    };

    static shapeNote = (
        item: NotesAndActivitiesOrientationNote,
        forOrientationNote: boolean,
        sanitizer: DomSanitizer
    ): NotesAndActivities => {
        if (forOrientationNote) {
            item.note = item.orientationNote;
        }
        if (!item.note) {
            return item;
        }
        item.noteText = item.note as string;
        item.note = NotesHelper.getRawHtml(item.noteText, item.noteTypeId, sanitizer);
        if (
            item.noteTypeId === NoteAndActivityTypeEnum.System ||
            item.noteTypeId === NoteAndActivityTypeEnum.SystemEmail ||
            item.noteTypeId === NoteAndActivityTypeEnum.LabProviderEmail
        ) {
            item.userName = 'System';
        }
        return item;
    };
}
